import React, { useState, useEffect, useRef } from 'react';
import { CButton, CCol, CRow, CInput, CTabs, CNav, CNavItem, CNavLink, CLabel, CSelect, CFormGroup, CModal, CModalHeader, CModalTitle, CModalFooter, CModalBody, CTextarea, CPagination, CTooltip } from '@coreui/react';

import 'react-circular-progressbar/dist/styles.css';
import './ProjectDetails.css';
import Loading from '../aimhi-widgets/Loading';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useReactToPrint } from 'react-to-print';
import ThingsToConsider from '../aimhi-widgets/ThingToConsider';
import PrintPurchaseRequest from './PrintPurchaseRequest';
import $axios from 'src/utils/axios';
import Select from 'react-select';
import { requestMaterialNotifications } from 'src/redux/actions/notifications';
import { FaPencilAlt } from 'react-icons/fa';
import { useLocation } from 'react-router-dom';
import debounce from 'lodash/debounce';
import MaterialUtilizationProject from '../resource-records/material/MaterialUtilizationProject';
import StockBalance from '../resource-records/material/StockBalance';
import useCheckPermission from 'src/utils/useCheckPermission';
import { showError } from 'src/utils/swalError';
import ProjectTabs from '../projects/ProjectTabs';
import queryString from 'query-string';
import { trackEvent, mixPanelEvents } from 'src/utils/mixpanel';
import MaterialAssign from './MaterialAssign';
const Materials = (props) => {
  const Swal = require('sweetalert2');
  const { id: projectID } = useParams();
  let user_id = parseInt(localStorage.getItem('user_id'));
  const company_id = parseInt(localStorage.getItem('company_id'));
  const accessToken = localStorage.getItem('token');
  const projectInfo = useSelector((state) => state.project.projectInfo[projectID]);
  const [active, setActive] = useState(1);
  const [clickPrintNotif, setClickPrintNotif] = useState(false);
  const [modal, setModal] = useState(false);
  const [modalEmail, setmodalEmail] = useState(false);
  const [listOfMaterial, setlistOfMaterial] = useState([]);
  const [purchaseRequest, setpurchaseRequest] = useState({});
  const [dataRequest, setDataRequest] = useState([]);
  const [searchValue, setSearchValue] = useState('');
  const [addMaterial, setAddMaterial] = useState([
    {
      Description: '',
      Unit: '',
      Qty: '',
    },
  ]);
  const [description, setdescription] = useState(false);
  const [unit, setunit] = useState(false);
  const [qty, setqty] = useState(false);
  const [print, setprint] = useState(false);
  const [projectId, setprojectId] = useState('');
  const [materialAll, setmaterialAll] = useState([]);
  const [email, setemail] = useState('');
  const [currentPage, setcurrentPage] = useState(1);
  const [postperPage, setpostperPage] = useState(10);
  const [paginateInitial, setPaginateInitial] = useState(0);
  const [paginateAction, setPaginateAction] = useState('');
  const [requestHistory, setRequestHistory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState('');
  const [createRequest, setCreateRequest] = useState([]);
  const checkPermission = useCheckPermission();
  const [companyName, setCompanyName] = useState('');
  const [location, setLocation] = useState('');
  const [businessEmail, setBusinessEmail] = useState('');
  const [businessPhone, setBusinessPhone] = useState('');
  const [companyProfilePicture, setcompanyProfilePicture] = useState('');
  const [department, setDepartment] = useState('');
  const [originalQuantities, setOriginalQuantities] = useState({});
  const { search: searchLocation } = useLocation();
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });


  useEffect(() => {
    let user_id = parseInt(localStorage.getItem('user_id'));
    requestMaterialNotifications(company_id, projectID);
    setprojectId(projectID);
    getproject(projectID);
    gitRequstHistory(projectID);
    getCompanyData(company_id);
    GetUsersById(user_id);
  }, []);


  useEffect(() => {
    setSearchValue('');
  }, [active]);

  useEffect(() => {
    const parsed = queryString.parse(searchLocation);
    if (!parsed?.search) return;
    setSearchValue(parsed?.search);

  }, [searchLocation]);

  const handleRedirectOnLowStock = (materialName) => {
    setActive(1);
    setSearchValue(materialName);
  };

  if ('matchMedia' in window) {
    // Chrome, Firefox, and IE 10 support mediaMatch listeners
    window.matchMedia('print').addListener(function (media) {
      if (media.matches) {
        beforePrint();
      } else {
        // Fires immediately, so wait for the first mouse movement
        afterPrint();
      }
    });
  } else {
  }

  const beforePrint = () => {
    setClickPrintNotif(true);
  };

  const afterPrint = () => {
    setClickPrintNotif(false);
  };

  let pageNumbers = [];

  const paginateArray = () => {
    const startIndex = currentPage <= 0 ? 0 : (currentPage - 1) * 10;
    const endIndex = startIndex + 10;

    return listOfMaterial.length > 0 ? listOfMaterial.filter((a) => Object.values(a).some((value) => String(value).toLowerCase().includes(searchValue.toLowerCase()))).slice(startIndex, endIndex) : [];
  };

  for (let i = 1; i <= Math.ceil(listOfMaterial.length / postperPage); i++) {
    if (i <= 5 && paginateAction == '') {
      pageNumbers.push(i);
    } else if (paginateAction == 'next') {
      if (i > paginateInitial && i <= paginateInitial + 5) {
        pageNumbers.push(i);
      }
    } else if (paginateAction == 'prev') {
      if (i <= paginateInitial) {
        pageNumbers.push(i);
      }
    }
  }


  const gitRequstHistory = (project_id) => {
    const company_id = parseInt(localStorage.getItem('company_id'));
    $axios.get(`material/request-history/${company_id}/${project_id}`).then((res) => {
      setRequestHistory(res.data.response.data);
    });
  };

  const getproject = (project_id) => {
    $axios
      .post('material/project/list', {
        project_id,
        company_id: company_id,
      })
      .then((res) => {
        setlistOfMaterial(res.data.response);
        setcurrentPage(1);
        setDataRequest(res.data.response);
        setLoading(false);

        let arr = [];

        res.data.response.forEach((data) => {
          arr.push(data.MaterialName);
        });

        setmaterialAll(arr);
      })
      .catch((error) => {
        if (error?.response?.status === 403) {
          showError(error?.response?.data?.response, "Permission Denied");
          return;
        }
        console.log('projectdetails/Material.js', ' ', 'line 196', error);
      });
  };


  const clickPrint = (project_id, pr_number) => {
    const company_id = parseInt(localStorage.getItem('company_id'));
    $axios.get(`material/request-history/details/${company_id}/${project_id}/${pr_number}`).then((res) => {
      setpurchaseRequest(res.data.response.data);
    });

    setActive(3);
  };

  const materialoption = materialAll.map((item, Index) => {
    return <option key={Index} value={item}></option>;
  });

  const add = () => {
    let arr = [...addMaterial];
    arr.push({
      Description: '',
      Unit: '',
      Qty: '',
    });
    setdescription(false);
    setqty(false);
    setunit(false);
    setAddMaterial(arr);
  };

  const QuantityOnChange = (e, materialIndex) => {
    let arr = [...listOfMaterial];
    let req = [...dataRequest];
    let Index = arr.findIndex((a) => a.index == materialIndex);
    arr[Index].NoOfOrders = parseFloat(e.target.value);
    req[materialIndex].NoOfOrders = parseFloat(e.target.value);

    setlistOfMaterial(arr);
    setDataRequest(req);
  };

  const clickEdit = (index) => {
    let arr = [...requestHistory];

    arr[index]['edit'] = true;

    setRequestHistory(arr);
  };

  const remarks = (e, index) => {
    let arr = [...requestHistory];

    arr[index]['remarks'] = e.target.value;

    setRequestHistory(arr);
  };

  const saveDateDelivered = (e, index, id, pr_num, remarks) => {
    const company_id = parseInt(localStorage.getItem('company_id'));
    let data = {
      id: id,
      pr_num: pr_num,
      updates: {
        remarks: remarks,
      },
    };

    $axios
      .put(`material/request-history/${company_id}/${projectID}`, {
        ...data,
      })
      .then((res) => {
        if (res.data.status == 200) {
          let arr = [...requestHistory];

          arr[index]['edit'] = false;

          setRequestHistory(arr);
          gitRequstHistory(projectID);
        }
      });
  };

  const PrHistory = requestHistory.map((data, Index) => {
    let color = '#25C6E3';
    if (data['approval_status'] == 'Approved') {
      color = '#3A7D21';
    } else if (data['approval_status'] == 'Disapproved') {
      color = '#B42A19';
    }
    return (
      <tr key={Index}>
        <td>{Index + 1}</td>
        <td>{data.pr_number}</td>
        <td>{data.preparer}</td>
        <td>{data.request_date}</td>
        <td>
          <CCol style={{ padding: '0' }}>
            <CRow>
              <CCol xl="10">
                <CTextarea
                  onChange={(e) => remarks(e, Index)}
                  onBlur={(e) => saveDateDelivered(e, Index, data.id, data.pr_number, data.remarks)}
                  onKeyPress={(e) => {
                    if (e.key == 'Enter') {
                      saveDateDelivered(e, Index, data.id, data.pr_number, data.remarks);
                    }
                  }}
                  onClick={(e) => {
                    console.log(data['remarks']);
                  }}
                  value={data['remarks']}
                  disabled={data.edit != true}
                ></CTextarea>
              </CCol>
              <CCol xl="2">
                <FaPencilAlt onClick={() => clickEdit(Index)} />
              </CCol>
            </CRow>
          </CCol>
        </td>
        <td style={{ color: color }}>{data['approval_status']}</td>
        <td>
          <CButton variant="outline" block color="aimhi-primary" onClick={() => clickPrint(projectID, data.pr_number, data.preparer, data.request_date, data.notes, data.approver, data.position, data.data_approved)}>
            Print
          </CButton>
        </td>
      </tr>
    );
  });

  const listmaterial = paginateArray().map((item, Index) => {
    let progress = parseInt(item.TotalQuantity) === 0 ? 0 : (parseInt(item.TotalOrder) / parseInt(item.TotalQuantity)) * 100;

    let color = '#3a7d21'; // Default: Green (Success)

    if (progress > 100) {
      color = '#b42a19'; // Danger (Over 100%)
    } else if (progress >= 90) {
      color = '#b6451d'; // High Warning (90% - 100%)
    } else if (progress >= 75) {
      color = '#f2e442'; // Warning (75% - 89%)
    } else if (progress >= 50) {
      color = '#3a7d21'; // Success (50% - 74%)
    }

    return (
      <CCol style={{ marginTop: '10px', padding: '0px' }} key={Index}>
        <CRow>
          <CCol xs="12" sm="12" md="12" lg="4">
            <CRow>
              {item?.tag_name ? (
                <CTooltip content={item.tag_name}>
                  <span>{item.MaterialName}</span>
                </CTooltip>
              ) : (
                <span>{item.MaterialName}</span>
              )}
            </CRow>
          </CCol>
          <CCol xs="12" sm="12" md="12" lg="6">
            <div className="progress" style={{ height: '20px', borderRadius: '10px', overflow: 'hidden', backgroundColor: '#e0e0e0', position: 'relative' }}>
              <div
                className="progress-bar"
                role="progressbar"
                style={{
                  width: progress + '%',
                  backgroundColor: color,
                  position: 'absolute',
                  height: '100%',
                }}
              ></div>

              <div className="d-flex align-items-center w-100 h-100 position-relative" style={{ fontWeight: 'bold', padding: '0 8px', whiteSpace: 'nowrap' }}>
                <div className="position-absolute" style={{ left: '50%', color: progress <= 50 ? '#000' : (progress >= 75 && progress < 100 ? '#000' : '#fff') }}>
                  {item.TotalOrder}
                </div>
                <div className="ml-auto" style={{ color: progress <= 90 ? '#000' : '#fff' }}>
                  {item.TotalOrder}/{item.TotalQuantity} {item.Unit}
                </div>
              </div>
            </div>
          </CCol>
          <CCol xs="12" sm="12" md="12" lg="2">
            <CInput
              type="number"
              size="sm"
              className="input_number_spin"
              onChange={(e) => QuantityOnChange(e, item.index)}
              onWheel={(e) => e.target.blur(e)}
              value={item.NoOfOrders}
              step="any"
            />
          </CCol>
        </CRow>
      </CCol>
    );
  });


  const UnitOnChange = (e, Index) => {
    let arr = [...addMaterial];
    arr[Index].Unit = e.target.value;

    if (e.target.value !== '') {
      setunit(true);
    } else {
      setunit(false);
    }
    setAddMaterial(arr);
  };

  const QtyOnChange = (e, Index) => {
    let arr = [...addMaterial];
    arr[Index].Qty = e.target.value;

    if (e.target.value !== '') {
      setqty(true);
    } else {
      setqty(false);
    }
    setAddMaterial(arr);
  };

  const submitmaterial = () => {
    const company_id = parseInt(localStorage.getItem('company_id'));
    $axios
      .post('material/project/add', {
        Materials: addMaterial,
        project_id: projectId,
        company_id: company_id,
      })
      .then(function (response) {
        setlistOfMaterial(response.data.response);
      });


    setModal(false);
  };

  const send = () => {
    $axios
      .post('material/sentmail', {
        receiver: email,
        purchase_request: purchaseRequest,
      })
      .then(function (response) {
        if (response.data.status == 1) {
          setmodalEmail(false);
          Swal.fire({
            icon: 'success',
            title: 'Email already sent',
            showConfirmButton: false,
          });
        }
      });
  };

  const search = debounce((e) => {
    setSearchValue(e);
  }, 30);

  const AddMaterialModal = addMaterial.map((item, Index) => {
    return (
      <tr key={Index}>
        <td>
          <Select size="sm" style={{ border: 'none' }} options={materialAll} />
        </td>
        <td>
          <CSelect size="sm" className="form-boderless" onChange={(e) => UnitOnChange(e, Index)} value={item.Unit}>
            <option value="">Select Unit</option>
            <option value="kls.">kls.</option>
            <option value="Lgts.">Lgts.</option>
            <option value="pcs.">pcs.</option>
            <option value="set.">set.</option>
          </CSelect>
        </td>
        <td>
          <CInput type="number" size="sm" className="form-boderless" onChange={(e) => QtyOnChange(e, Index)} value={item.Qty} step="any" />
        </td>
      </tr>
    );
  });

  if (clickPrintNotif == true) {
    return (
      <CCol>
        <span style={{ fontSize: '25px', fontWeight: 'Bold' }}>Please use print request button to print!!</span>
      </CCol>
    );
  }

  const GetUsersById = (user_id) => {
    $axios
      .post('account/user/info', {
        user_id,
      })
      .then(function (response) {
        if (response.data.status == 1) {
          setDepartment(response.data.response.department);
        }
      });
  };

  const getCompanyData = (company_id) => {
    $axios
      .get(`company/info/${company_id}`, {
        company_id,
      })
      .then(function (response) {
        if (response.data.status == 1) {
          setCompanyName(response.data.response.name);

          setLocation(response.data.response.location);
          setBusinessEmail(response.data.response.business_email);
          setBusinessPhone(response.data.response.contact_num);

          setcompanyProfilePicture(response.data.response.company_pic);
        } else {
          Swal.fire({
            icon: 'error',
            title: response.data.response,
            text: response.data.description,
            confirmButtonColor: '#23303D',
          });
        }
      });
  };

  const handleNavSubmit = () => {
    let matarr = [...dataRequest];
    let data = matarr.filter((a) => a.NoOfOrders > 0);
    let submit = [];
    for (var i in data) {
      submit.push({
        material_id: data[i].material_id,
        material_name: data[i].items.item,
        sow_id: data[i].sow_id,
        psow_id: data[i].psow_id,
        total_order: data[i].NoOfOrders,
        unit: data[i].items.unit,
        pm_id: data[i].pm_id,
        notes: data[i].items.notes,
      });
    }

    $axios
      .post('material/request', {
        user_id: user_id,
        purchase_request: submit,
        token: accessToken,
        project_id: projectId,
        company_id: company_id,
      })
      .then(function (response) {
        submit.forEach(item => {
          const { pm_id, ...rest } = item;
          trackEvent(mixPanelEvents.REQUEST_MATERIAL, {
            'Source': 'Project - Materials',
            'project_id': projectID,
            ...rest
          });
        });
        setActive(2);
        setActiveTab('');
        getproject(projectID);
        gitRequstHistory(projectID);
        requestMaterialNotifications(company_id, projectId);
        Swal.fire('Saved!', '', 'success');
      });
  };

  const handleNavClick = (tabName) => {
    if (tabName === '') {
      const updatedListOfMaterial = listOfMaterial.map((item) => ({
        ...item,
      }));
      setSearchValue('');
      setlistOfMaterial(updatedListOfMaterial);
      setDataRequest(updatedListOfMaterial);
    }
    setActiveTab(tabName);
  };


  const quantityChange = (e, index, tx_id) => {
    let arr = [...createRequest];
    let originalQty = arr[index].items.qty;
    arr[index].items.qty = e.target.value;
    setCreateRequest(arr);

    setOriginalQuantities((prevQuantities) => ({
      ...prevQuantities,
      [index]: originalQty,
    }));
  }
  const handleBlur = (e, index) => {
    let arr = [...createRequest];
    let newValue = e.target.value.trim();
    if (newValue === '') {
      arr[index].items.qty = originalQuantities[index];
      setCreateRequest(arr);
    }

    let matarr = [...dataRequest];
    matarr[index].NoOfOrders = parseFloat(arr[index].items.qty);
    setDataRequest(matarr);
  };


  const editNotes = (index) => {
    let arr = [...createRequest];
    arr[index]['edit_notes'] = true;
    setCreateRequest(arr);
  };

  const noteChange = (e, index, tx_id) => {
    let arr = [...createRequest];
    arr[index].items.notes = e.target.value;
    setCreateRequest(arr);
  };

  const noteOnBlur = (index) => {
    let arr = [...createRequest];
    arr[index]['edit_notes'] = false;
    setCreateRequest(arr);
  };

  const CreateRequest = () => {
    let matarr = [...dataRequest];
    let data = matarr.filter((a) => a.NoOfOrders > 0);
    if (data.length === 0) {
      Swal.fire({ title: 'Request a material first.', icon: 'error', confirmButtonColor: '#23303D' });
    } else {
      let arr = [];
      for (var i in data) {
        arr.push({
          approver: '',
          approver_position: '',
          date_approved: '',
          date_requested: '',
          pr_num: '',
          preparer: '',
          preparer_position: '',
          items: {
            item: data[i].MaterialName,
            notes: data[i].notes || '',
            pr_id: '',
            qty: data[i].NoOfOrders,
            tx_id: '',
            unit: data[i].Unit,
          },
          material_id: data[i].material_id,
          pm_id: data[i].pm_id,
          sow_id: data[i].sow_id,
          psow_id: data[i].psow_id,
          total_order: data[i].NoOfOrders,
          NoOfOrders: data[i].NoOfOrders,
        });
      }

      setCreateRequest(arr);
      setDataRequest(arr);
      handleNavClick('Nav1');
    }
  };

  return (
    <>
      {loading ? <Loading /> : ''}
      <ProjectTabs />
      <CRow>
        <CCol xs="12" sm="12" md="12" lg="12" xl="9" style={{ marginTop: '20px' }}>
          <CTabs>
            <CNav variant="tabs" className="!border-b-[6px]">
              <CNavItem>
                <CNavLink className={active == 1 ? 'nav-design-active' : 'nav-design'} onClick={() => setActive(1)}>
                  Material List
                </CNavLink>
              </CNavItem>
              {checkPermission('/material/assign/create') && (
                <CNavItem>
                  <CNavLink className={active == 6 ? 'nav-design-active' : 'nav-design'} onClick={() => setActive(6)}>
                    Material Assign
                  </CNavLink>
                </CNavItem>
              )}
              <CNavItem>
                <CNavLink
                  className={active == 2 || active == 3 ? 'nav-design-active' : 'nav-design'}
                  onClick={() => {
                    setActive(2);
                    handleNavClick('');
                  }}
                >
                  Request History
                </CNavLink>
              </CNavItem>

              {checkPermission('/onsite-records/material/StockBalance') && (
                <CNavItem>
                  <CNavLink
                    className={active == 4 ? 'nav-design-active' : 'nav-design'}
                    onClick={() => {
                      setActive(4);
                      handleNavClick('');
                    }}
                  >
                    Stock Balance
                  </CNavLink>
                </CNavItem>
              )}

              {checkPermission('/onsite-records/material/MaterialUtilization') && (
                <CNavItem>
                  <CNavLink
                    className={active == 5 ? 'nav-design-active' : 'nav-design'}
                    onClick={() => {
                      setActive(5);
                      handleNavClick('');
                    }}
                  >
                    Material Utilization
                  </CNavLink>
                </CNavItem>
              )}
            </CNav>
            {active === 1 && activeTab !== 'Nav1' && (
              <div>
                <CCol style={{ padding: '0px' }}>
                  <CRow>
                    <CCol xs="12" sm="12" md="4" lg="4" style={{ marginTop: '20px' }}>
                      <label className="form-label" for="exampleDataList">
                        Search
                      </label>
                      <input value={searchValue} type="search" className="form-control" id="exampleDataList" list="datalistOptions" placeholder="Type material name to search...." onChange={(e) => search(e.target.value)} />
                      <datalist id="datalistOptions">{materialoption}</datalist>
                    </CCol>
                    <CCol xs="12" sm="12" md="12" lg="12" style={{ marginTop: '20px' }}>
                      <CRow>
                        <CCol xs="12" sm="12" md="6" lg="10"></CCol>

                        <CCol xs="12" sm="12" md="12" lg="2">
                          {checkPermission('/material/request') && (
                            <CButton block color="aimhi-primary" size="sm" onClick={() => CreateRequest()}>
                              Create request
                            </CButton>
                          )}
                        </CCol>
                      </CRow>
                    </CCol>
                    <CCol xs="12" sm="12" md="12" lg="12">
                      {listmaterial}
                      <CCol md="12" style={{ padding: '0', marginTop: '20px' }}>
                        <nav className="float-left">
                          <CPagination activePage={currentPage} pages={Math.ceil(listOfMaterial.filter((a) => Object.values(a).some((value) => String(value).toLowerCase().includes(searchValue.toLowerCase()))).length / 10)} onActivePageChange={(e) => setcurrentPage(e)} />
                        </nav>
                      </CCol>
                    </CCol>
                  </CRow>
                </CCol>
              </div>
            )}

            {active == 1 && activeTab === 'Nav1' && (
              <>
                <div>
                  <CCol style={{ padding: '0px' }}>
                    <CRow>
                      <CCol xs="12" sm="12" md="12" lg="12" style={{ marginTop: '20px' }}>
                        <CRow>
                          <CCol xs="12" sm="12" md="12" lg="8"></CCol>
                          <CCol xs="12" sm="12" md="12" lg="2">
                            {checkPermission('/material/request') && (
                              <CButton variant="outline" style={{ backgroundColor: '#23303d', color: 'white' }} size="sm" block onClick={() => handleNavSubmit()}>
                                <span>Submit</span>
                              </CButton>
                            )}
                          </CCol>
                          <CCol xs="12" sm="12" md="12" lg="2">
                            {checkPermission('/material/request') && (
                              <CButton variant="outline" style={{ backgroundColor: '#6e7d88', color: 'white' }} size="sm" block onClick={() => handleNavClick('')}>
                                <span>Cancel</span>
                              </CButton>
                            )}
                          </CCol>
                        </CRow>
                      </CCol>
                      <CCol xs="12" sm="12" md="12" lg="12">
                        <div>
                          <table className="table table-bordered" style={{ marginTop: '20px' }}>
                            <tr style={{ fontWeight: 'bold' }}>
                              <td colSpan={6} style={{ textAlign: 'center' }}>
                                <img src={companyProfilePicture} style={{ width: '100px', height: '100px' }} />
                                <div>
                                  <span>{companyName}</span>
                                </div>
                                <div>
                                  <span>{location}</span>
                                </div>
                                <div style={{ marginTop: '15px' }}>
                                  <span>Purchase Requisition</span>
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td colSpan={2}>
                                <div>
                                  <span style={{ fontWeight: 'bold' }}>Department :</span>
                                  <span style={{ marginLeft: '5px' }}>{department}</span>
                                </div>
                                <div>
                                  <span style={{ fontWeight: 'bold' }}>Project Name :</span>
                                  <span style={{ marginLeft: '5px' }}>{projectInfo?.project_name}</span>
                                </div>
                              </td>
                              <td colSpan={3} style={{ textAlign: 'right' }}>
                                <div>
                                  <span style={{ fontWeight: 'bold' }}>Date Requested :</span>
                                  <span style={{ marginLeft: '5px' }}>{new Date().toLocaleDateString()}</span>
                                </div>
                                <div>
                                  <span style={{ fontWeight: 'bold' }}>Pr Number :</span>
                                  <span style={{ marginLeft: '5px' }}>{props.purchaserequest?.pr_num ?? ''}</span>
                                </div>
                              </td>
                            </tr>
                          </table>
                          <table className="table table-bordered" style={{ marginTop: '20px' }}>
                            <thead>
                              <tr>
                                <th>Item</th>
                                <th>Item Description</th>
                                <th>Quantity</th>
                                <th>Unit</th>
                                <th>Notes (optional)</th>
                              </tr>
                            </thead>
                            <tbody>
                              {createRequest.map((item, Index) => {
                                return (
                                  <tr key={Index}>
                                    <td>{Index + 1}</td>
                                    <td>{item.items.item}</td>
                                    <td>
                                      <input
                                        type="text"
                                        value={item.items.qty}
                                        onChange={(e) => quantityChange(e, Index, item.items.tx_id)}
                                        onBlur={(e) => handleBlur(e, Index)}
                                        style={{ width: 80, border: '1px solid #707070c0' }}
                                      />
                                    </td>

                                    <td
                                    >
                                      <span>{item.items.unit}</span>
                                    </td>
                                    <td onClick={() => editNotes(Index)} style={{ cursor: 'pointer' }}>
                                      {item['edit_notes'] == true ? <CTextarea value={item.items.notes} onChange={(e) => noteChange(e, Index, item.items.tx_id)} onBlur={(e) => noteOnBlur(Index)}></CTextarea> : <span>{item.items.notes}</span>}
                                    </td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </table>
                          <table className="table table-bordered">
                            <tbody style={{ textAlign: 'center' }}>
                              <tr style={{ fontSize: '12px' }}>
                                <td>Requested by:</td>
                                <td>Prepared by:</td>
                                <td style={{ width: '250px' }}>Notes:</td>
                                <td>Date Approved:</td>
                                <td colSpan={2}>Approved by:</td>
                              </tr>
                              <tr style={{ fontSize: '12px' }}>
                                <td style={{ verticalAlign: 'bottom', height: '60px' }}>
                                  <span className="pointer"> </span>
                                </td>
                                <td style={{ verticalAlign: 'bottom' }}>{/* {category == 'Fuel' ? props.fuel?.preparer : props.equipment?.preparer} */}</td>
                                <td>{/* {category == 'Fuel' ? props.fuel?.notes : props.equipment?.notes} */}</td>
                                <td rowSpan={2} style={{ verticalAlign: 'bottom' }}>
                                  <span>{/* {category == 'Fuel' ? props.fuel?.date_approved : props.equipment?.date_approved} */}</span>
                                </td>
                                <td colSpan={2} rowSpan={2} style={{ verticalAlign: 'bottom' }}>
                                  {/* {category == 'Fuel' ? props.fuel?.approver : props.equipment?.approver} */}
                                  <div>
                                    <span>{/* {category == 'Fuel' ? props.fuel?.approver_position : props.equipment?.approver_position} */}</span>
                                  </div>
                                </td>
                              </tr>
                              <tr style={{ fontSize: '12px' }}>
                                <td>
                                  <span className="pointer"> </span>
                                </td>
                                <td>{/* {category == 'Fuel' ? props.fuel?.preparer_position : props.equipment?.preparer_position} */}</td>
                              </tr>
                            </tbody>
                          </table>
                          <CCol xs="12" sm="12" md="12" lg="12" xl="12" style={{ padding: '0px' }}>
                            <ThingsToConsider project_id={projectID} handleRedirectOnLowStock={handleRedirectOnLowStock} />
                          </CCol>
                        </div>
                      </CCol>
                    </CRow>
                  </CCol>
                </div>
              </>
            )}
            {active == 3 && (
              <CCol style={{ padding: '0px' }}>
                <CRow>
                  <CCol xs="12" sm="12" md="12" lg="12" style={{ marginTop: '20px' }}>
                    <CRow>
                      <CCol xs="12" sm="12" md="12" lg="8"></CCol>
                      <CCol xs="12" sm="12" md="12" lg="2">
                        {checkPermission('/material/request') && (
                          <CButton variant="outline" color="aimhi-textlight-neutral" size="sm" block onClick={() => handlePrint(setprint(true))}>
                            <span>Print request</span>
                          </CButton>
                        )}
                      </CCol>
                      <CCol xs="12" sm="12" md="12" lg="2">
                        {checkPermission('/material/sentmail') && (
                          <CButton variant="outline" color="aimhi-textlight-neutral" size="sm" block onClick={() => setmodalEmail(true)}>
                            <span>Email request</span>
                          </CButton>
                        )}
                      </CCol>
                    </CRow>
                  </CCol>
                  <CCol xs="12" sm="12" md="12" lg="12">
                    <PrintPurchaseRequest
                      ref={componentRef}
                      purchaserequest={purchaseRequest}
                      print={print}
                      project_name={projectInfo?.project_name}
                      project_id={projectID}
                    />
                  </CCol>
                </CRow>
              </CCol>
            )}

            {active == 2 && (
              <table className="table">
                <thead>
                  <tr>
                    <th>No</th>
                    <th>PR Number</th>
                    <th>Preparer</th>
                    <th>Request Date</th>
                    <th>Remarks</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>{PrHistory}</tbody>
              </table>
            )}

            {active == 4 && (
              <div style={{ marginTop: '12px' }}>
                <MaterialUtilizationProject project_id={projectId} />
              </div>
            )}
            {active == 5 && (
              <div style={{ marginTop: '12px' }}>
                <StockBalance from_project_module={true} projectID={projectId} />
              </div>
            )}
            {active === 6 && (
              <div style={{ marginTop: '12px' }}>
                <MaterialAssign projectID={projectId} companyID={company_id} />
              </div>
            )}
          </CTabs>
        </CCol>

        <CCol xs="12" sm="12" md="12" lg="12" xl="3">
          {active != 3 && <ThingsToConsider project_id={projectID} handleRedirectOnLowStock={handleRedirectOnLowStock} />}
        </CCol>
      </CRow>

      <CModal size="lg" show={modal} onClose={() => setModal(!modal)} style={{ borderRadius: '10px' }}>
        <CModalHeader closeButton style={{ borderColor: 'white' }}>
          <CModalTitle>Add New Material</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <table className="table table-bordered">
            <thead>
              <tr>
                <th style={{ width: '250px' }}>Description</th>
                <th>Unit</th>
                <th>Quantity</th>
              </tr>
            </thead>
            <tbody>{AddMaterialModal}</tbody>
          </table>

          <CButton
            // color="link"
            onClick={() => add()}
            disabled={!unit || !qty || !description}
          >
            <u>Add More</u>
          </CButton>
        </CModalBody>
        <CModalFooter style={{ borderColor: 'white' }}>
          <CCol md="4" sm="4" lg="4" xl="4">
            <CButton variant="outline" block color="aimhi-textlight-neutral" size="sm" onClick={() => submitmaterial()} disabled={!qty || !unit || !description}>
              Submit
            </CButton>
          </CCol>
        </CModalFooter>
      </CModal>
      <CModal show={modalEmail} onClose={() => setmodalEmail(!modalEmail)} style={{ borderRadius: '5px' }}>
        <CModalHeader closeButton style={{ borderColor: 'white' }}>
          <CModalTitle>SEND E-MAIL</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <CCol md="12" sm="12" lg="12" xl="12">
            <CFormGroup row>
              <CLabel sm="2" col="sm" htmlFor="input-small">
                TO:
              </CLabel>
              <CCol sm="6">
                <CInput size="sm" type="email" id="input-small" className="input-sm" placeholder="example@gmail.com" value={email} onChange={(e) => setemail(e.target.value)} />
              </CCol>
            </CFormGroup>
          </CCol>
        </CModalBody>
        <CModalFooter style={{ borderColor: 'white' }}>
          <CCol md="4" sm="4" lg="4" xl="4">
            <CButton block color="aimhi-primary" size="sm" onClick={() => send()} disabled={email == ''}>
              SEND
            </CButton>
          </CCol>
        </CModalFooter>
      </CModal>
    </>
  );
};

export default Materials;
